import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import React from 'react';
export const UserProfileStep = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box borderRadius="3xl" width="full" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};